import { formatPhoneNumberForDisplay, PhoneNumberFormat } from "@remi/formatting/phone";
import { RemiButton, type RemiButtonProps } from "@remi/next-ui";

type CallButtonProps = RemiButtonProps & {
  number?: string;
};

export const CallButton = ({ number, className, "aria-label": ariaLabel, ...props }: CallButtonProps) => {
  const defaultAriaLabel = number
    ? `Call ${formatPhoneNumberForDisplay(number, { format: PhoneNumberFormat.NATIONAL })}`
    : undefined;

  return (
    <a href={number ? `tel:${number}` : undefined} className={className} aria-label={ariaLabel ?? defaultAriaLabel}>
      <RemiButton {...props} className={className} disabled={!number ? true : props.disabled} />
    </a>
  );
};
